import { Card, CardTitle, CardBody, CardFooter, Badge } from "reactstrap"
import { Link } from "react-router-dom"
import { isButtonDisabled } from "../../utils/expense"

export default function ExpenseGroupCard({
  expenseGroup,
}) {
  const { id, name, description, created_at } = expenseGroup
  return (
    <Card className={`mb-4 ${!isButtonDisabled(created_at) ? "shadow" : ""}`}  >
      <CardBody className="py-4">
        <CardTitle tag={"h4"} className="text-muted">
          {name}
        </CardTitle>
        <p>{description}</p>

        {isButtonDisabled(created_at) && (
          <Badge color="danger" style={{ opacity: 0.8 }}>Closed</Badge>
        )
        }
      </CardBody>

      <CardFooter className="d-flex justify-content-between p-3">

        <Link
          to={`/expense-group/${id}`}
          className="btn text-secondary border-0"
        >
          <i className="bx bx-file mr-1"></i>
        </Link>

        {isButtonDisabled(created_at) ? (
          <button className="btn text-primary border-0  disabled">
            <i className="bx bx-dollar "></i>
          </button>
        ) : (
          <Link className="btn btn-primary" to={`/add-expense/${id}`}>
            <i className="bx bx-dollar"></i>
          </Link>
        )}


        <Link
          to={`/create-edit-expense-group?groud_id=${id}`}
          className="btn border-0 text-warning "
        >
          <i className="bx bx-edit mr-1  "></i>
        </Link>
      </CardFooter>
    </Card>
  )
}
